module.exports = __webpack_public_path__ + "static/img/diyiimg5.4148b0d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/cardiobrain/diyiimg5.png
// module id = p6jD
// module chunks = 5